import { render, staticRenderFns } from "./SoySocio.vue?vue&type=template&id=3fa50e00&"
import script from "./SoySocio.vue?vue&type=script&lang=js&"
export * from "./SoySocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports